<template>
	<v-layout column fill-height formlittle>
		<v-flex class="d-flex flex-row page-header formlittle flex-grow-0 mb-3">
			<h1>La matrice - {{ arborescence.nbproducts }} produits</h1>
			<v-spacer></v-spacer>

			<v-menu offset-y allow-overflow auto offset-overflow>
				<template v-slot:activator="{ on }">
					<v-btn class="primary2 mr-2" depressed v-on="on">Traductions</v-btn>
				</template>
				<v-list>
					<v-list-item>
						<v-list-item-title @click="tradsExport">Exporter les traductions</v-list-item-title>
					</v-list-item>
					<v-list-item>
						<v-list-item-title @click="tradsImport">Importer les traductions</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
			<!-- <v-btn class="primary2 mr-2" depressed @click="exportImages">Exporter images originales</v-btn> -->
			<v-btn class="primary2 mr-2" depressed @click="$refs.importImages.open()">Importer les images</v-btn>
			<v-btn class="primary2" depressed @click="$refs.importMatrice.open()">Importer la matrice</v-btn>
		</v-flex>
		<v-flex class="flex-grow-1 overflow-hidden">
			<v-card class="fill-height overflow-auto card-gray" flat>
				<v-card-text>
					<v-layout class="mx-2">
						<v-flex class="d-flex flex-row btn-switch">
							<p class="label-switch">Voir les familles</p>
							<v-switch
								v-model="showProducts"
								:name="$Utils.randomstring('showProducts')"
								color="#4e4e4e"
								:inset="true"
								:light="true"
								label="Voir les produits"
								class="mt-0 ml-4 mr-2"
								:hide-details="true"
							></v-switch>
						</v-flex>
					</v-layout>
					<catalog-search v-if="showProducts" @searchGo="searchGo" :catalog="0"></catalog-search>
					<hr />
					<card-tree
						v-if="!showProducts"
						:ca_id="0"
						:colProblems="true"
						:colCheckbox="false"
						:colEdit="true"
						:canSelectLine="false"
						path="/matrice"
						ref="cardtree"
						@treeloaded="treeLoaded"
					></card-tree>
					<m-card-products ref="cardProducts" v-if="showProducts"></m-card-products>
				</v-card-text>
			</v-card>
		</v-flex>
		<matrice-win-import @imported="imported" ref="importMatrice" what="la matrice" :ca_id="0"></matrice-win-import>
		<matrice-win-images ref="importImages" @imported="imported"></matrice-win-images>
		<matrice-win-trads :ca_id="0" ref="importTrads" @imported="imported"></matrice-win-trads>
	</v-layout>
</template>

<script>
import MatriceWinImport from "../views/MatriceWinImport";
import MatriceWinImages from "../views/MatriceWinImages";
import MatriceWinTrads from "../views/MatriceWinTrads";

export default {
	name: "matrice",
	components: {
		"matrice-win-import": MatriceWinImport,
		"matrice-win-images": MatriceWinImages,
		"matrice-win-trads": MatriceWinTrads
	},

	data() {
		return {
			arborescence: {},
			showProducts: false,
			//fa_idToLoadProduct: 0,
			showProductsIgnore: false
		};
	},
	watch: {
		showProducts(val) {
			if (this.showProductsIgnore) return;

			if (val) {
				//this.$router.push("/matrice/products/" + this.fa_idToLoadProduct);
				this.$router.push("/matrice/products");
			} else {
				this.$router.push("/matrice");
			}
		},
		$route(to, from) {
			// console.log("to", to);
			if (to.name === "matriceproducts") {
				//this.fa_idToLoadProduct = parseInt(to.params.fa_id);
				this.showProducts = true;
			}
			if (to.name === "matrice") {
				this.showProducts = false;
			}
		}
	},
	mounted() {
		if (this.$route.name === "matrice") {
			this.showProducts = false;
		}
		if (this.$route.name === "matriceproducts") {
			this.showProducts = true;
		}
		if (this.$route.name === "matriceproductsedit") {
			this.showProductsIgnore = true;
			this.showProducts = true;
			this.$nextTick(() => {
				this.$refs.cardProducts.openProduct(this.$route.params.pr_id);
				this.showProductsIgnore = false;
			});
		}
		// this.getMatrice({});
	},
	destroyed() {},
	methods: {
		exportImages() {
			window.open(this.$config.server_url + "/api/1.0/matrice/images/export?token=" + this.$store.state.token, "_blank");
		},
		productWinEditOpened(pr_id) {
			// console.log("pr_id", pr_id);
			this.$router.push("/matrice/products/edit/" + pr_id);
		},
		productWinEditSaved() {},
		productWinEditCanceled() {},
		treeLoaded(arborescence) {
			this.arborescence = arborescence;
		},
		async getMatrice(params) {
			this.$refs.cardtree.getCatalog();
			// let response = await this.$axios.get(
			//   this.$config.server_url + "/api/1.0/matrice",
			//   { params }
			// );
			// console.warn("response get matrice", response.data);
			// console.log(
			//   "",
			//   response.data.arborescence.children[0].children[0].products
			// );
			//this.nbProducts = response.data.products.length;
			// this.arborescence = response.data.arborescence;
			// this.addProductsToTree(
			//   response.data.arborescence,
			//   response.data.products
			// );
		},
		async searchGo(searchProduct, searchFamily, searchSubFamily, searchStatus, searchPromo) {
			let params = {
				searchProduct: searchProduct,
				searchFamily: searchFamily ? searchFamily.fa_id : searchFamily,
				searchSubFamily: searchSubFamily ? searchSubFamily.fa_id : searchSubFamily,
				searchStatus: searchStatus,
				searchPromo: searchPromo
			};
			//if (this.$refs.cardtree) this.$refs.cardtree.getCatalog();
			if (this.$refs.cardProducts) this.$refs.cardProducts.loadProducts(0, params);
		},
		addProductsToTree(tree, allProducts) {
			for (let b = 0; b < tree.children.length; b++) {
				const branche = tree.children[b];
				let products = allProducts.filter(p => {
					return p.fa_parent === branche.id;
				});
				//console.log("products", products);
				//if (products.length) branche.products.push(products);
				for (let ipr = 0; ipr < products.length; ipr++) {
					const product = products[ipr];
					product.indexLine = 0;
					product.level = branche.level + 1;
					branche.products.push(product);
					// console.log("branche.products", branche.products);
				}
				this.addProductsToTree(branche, allProducts);
			}
			this.arborescence = tree;
		},
		imported() {
			if (this.$refs.cardtree) this.$refs.cardtree.getCatalog();
			if (this.$refs.cardProducts) this.$refs.cardProducts.loadProducts(0);
		},
		tradsExport() {
			window.open(this.$config.server_url + "/api/1.0/matrice/tradsexport/0?token=" + this.$store.state.token, "_blank");
		},
		tradsImport() {
			this.$refs.importTrads.open();
		}
	}
};
</script>

<style lang="scss" rel="stylesheet/less" scoped>
.btn-switch {
	align-items: center;
	margin-bottom: 10px;
}
</style>
